import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const useEventValuesForEdit = (guID?: string) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["events", guID, "editInfo"],
    queryFn: () => getData(guID),
    enabled: !!guID,
  });

  return { data, isLoading, error };
};

const getData = async (guID?: string) => {
  
  const response = await axios.get(`/events/${guID}/edit/`);
  return response.data;
};

export default useEventValuesForEdit;

